import { render } from "./FlowRecordsAdmin.vue?vue&type=template&id=5f7172e3&scoped=true"
import script from "./FlowRecordsAdmin.vue?vue&type=script&lang=js"
export * from "./FlowRecordsAdmin.vue?vue&type=script&lang=js"

import "./FlowRecordsAdmin.vue?vue&type=style&index=0&id=5f7172e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7172e3"]])

export default __exports__